import { StatusMultiSelect } from '@/components/shared';
import { useState } from 'react';
import type { TopologyNode } from '@/services/observability-api';

export interface ArchitectureNodeFilterProps {
  nodes: TopologyNode[];
  selectedNodeIds: string[];
  noVisibleNodes?: boolean;
  adjacentTo?: string | undefined;
  onChange: (nodeIds: string[]) => void;
}

export function ArchitectureNodeFilter({
  nodes,
  selectedNodeIds,
  noVisibleNodes = false,
  adjacentTo,
  onChange,
}: ArchitectureNodeFilterProps) {
  const [open, setOpen] = useState(false);
  const adjacentLabel = nodes.find((node) => node.id === adjacentTo)?.label ?? adjacentTo;

  return (
    <StatusMultiSelect
      label="Visible nodes"
      options={nodes
        .map((node) => ({ value: node.id, label: node.label }))
        .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))}
      selectedStatuses={selectedNodeIds}
      onStatusesChange={onChange}
      open={open}
      onOpenChange={setOpen}
      allLabel="All nodes"
      pluralLabel="nodes"
      {...(adjacentTo
        ? { summary: `Adjacent to ${adjacentLabel}` }
        : noVisibleNodes
          ? { summary: 'No nodes' }
          : {})}
      visuallyHiddenLabel
    />
  );
}
